import React, { useState } from "react";
import Layout from "./Layout";
import { useNavigate } from "react-router-dom";
import TopCardP from "../ui/compoP/TopCardP";
import "../styles/main.scss";
import "../styles/compo.scss";
import "../styles/vars.scss";
import "../styles/ut.scss";
import SvgIcn from "../data/IconCompo";
import Popupz from "../ui/atoms/Popupz";

const UudTools = () => {
  const navigate = useNavigate();
  const [showAbout, setShowAbout] = useState(false);

  const toolsData = [
    {
      icon: "colorz_logo",
      title: "Colorz",
      text: "Color palette explorer with more than 2400 colors, search, and favorites",
      clickable: true,
      color: "honey",
      onClick: () => navigate("/ut/colorz"),
    },
    {
      icon: "compareimage_logo",
      title: "Compare Image",
      text: "Interactive image comparison tool with slider functionality",
      clickable: true,
      color: "honey",
      onClick: () => navigate("/ut/compareimage"),
    },
    {
      icon: "randomcolorz_logo",
      title: "Random Colorz",
      text: "Generate and explore random color combinations",
      clickable: true,
      color: "honey",
      onClick: () => navigate("/ut/randomcolorz"),
    },
    {
      icon: "timer_logo",
      title: "Timer",
      text: "Customizable countdown timer with visual and audio alerts",
      clickable: true,
      color: "honey",
      onClick: () => navigate("/ut/timer"),
    },
  ];

  return (
    <Layout selectedMode="utools" showLeftBar={false} showRightBar={false}>
      <div className="uudtools-page">
        <div className="uudtools-header">
          <div className="uudtools-header-top">
            <div className="uudtools-header-left">
              <SvgIcn name="service_b" className="uudtools-logo" />

            </div>

            <button
              type="button"
              className="uudtools-header-right-logo"
              aria-label="UUD"
              onClick={() => navigate("/")}
            >
              <SvgIcn name="logo01" />
            </button>
          </div>
          <h1 className="uudtools-title">UUD Tools</h1>
          <p className="uudtools-description">
            A UUD original collection of powerful utilities to enhance your digital workflow. These handcrafted tools are designed to boost creativity and streamline productivity in your everyday tasks.
          </p>
        </div>

        <div className="top-grid-ut">
          {toolsData.map((tool, index) => (
            <TopCardP key={index} {...tool} />
          ))}
        </div>

        <div className="uudtools-bottom-bar">
          <button
            type="button"
            className="uudtools-about-btn"
            onClick={() => setShowAbout(true)}
          >
            About
          </button>
          <div className="uudtools-copyright">© UUD 2026</div>
        </div>

        {showAbout && (
          <Popupz
            // title="UUD Tools"
            // icon="logo01"
            className="static-popup about"
            onClose={() => setShowAbout(false)}
          >
            <div className="static-hero">
              <h1 className="big-title">
                Original tools made by the <span>UUD team</span>
              </h1>

              <div className="static-content">
                <h2 className="title">UUD Tools</h2>
                <p>
                  UUD Tools is a set of original mini utilities built by the UUD
                  team for UX/UI designers—created from the same mindset we use
                  to design products: clarity first, minimal friction, strong
                  hierarchy.
                </p>
                <p>
                  These tools are intentionally small and focused. They’re meant
                  to support your daily workflow—exploring color palettes,
                  comparing visual details, generating quick ideas, and timing
                  sessions—without breaking your flow.
                </p>
                <p>
                  We’ll keep adding and refining tools as the UUD community grows
                  and as new needs appear. If something feels useful, it becomes
                  a tool. If it feels noisy, we simplify it.
                </p>
              </div>
            </div>
          </Popupz>
        )}
      </div>
    </Layout>
  );
};

export default UudTools;